import React, {Component} from "react";
import "./Button.css";

import {joinClasses} from "utils";

export default class Button extends Component
{
	constructor()
	{
		super();

		this.onClick = this.onClick.bind(this);
	}

	onClick()
	{
		if(!this.props.disabled)
			this.props.onClick();
	}

	render()
	{
		const classes = joinClasses(
		[
			"button-container",
			(this.props.disabled && "disabled")
		]);

		return (
			<div onClick={this.onClick} className={classes}>
				<span className="text">{this.props.children}</span>
				<span className="line -right"></span>
				<span className="line -top"></span>
				<span className="line -left"></span>
				<span className="line -bottom"></span>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Button/Button.js